(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-collection-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nova-console-nav')) {
    customElements.define('nova-console-nav', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.onHistoryChange = this.syncSelection.bind(this);
        this.onSectionLoad = this.observeCount.bind(this);
        this.countObserver = new MutationObserver(this.onHistoryChange);
        window.addEventListener('popstate', this.onHistoryChange);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onSectionLoad, { once: true });
        } else {
          this.observeCount();
        }
      }
      observeCount() {
        this.countObserver.disconnect();
        const count = document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop');
        if (count) this.countObserver.observe(count, { childList: true, subtree: true });
        this.syncSelection();
      }
      syncSelection() {
        const activeTags = new Set(new URLSearchParams(window.location.search).getAll('filter.p.tag'));
        const pills = Array.from(this.querySelectorAll('[data-nova-console-tag]'));
        const hasActiveConsole = pills.some(pill => pill.dataset.novaConsoleTag && activeTags.has(pill.dataset.novaConsoleTag));
        pills.forEach(pill => {
          const tag = pill.dataset.novaConsoleTag;
          const active = tag ? activeTags.has(tag) : !hasActiveConsole;
          pill.classList.toggle('is-current', active);
          if (active) pill.setAttribute('aria-current', 'page');
          else pill.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() {
        this.countObserver?.disconnect();
        window.removeEventListener('popstate', this.onHistoryChange);
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        document.removeEventListener('DOMContentLoaded', this.onSectionLoad);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-galaxy-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nova-product-tabs')) {
    customElements.define('nova-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        const tablist = this.querySelector('[data-tabs]');
        if (!tablist || !this.tabs.length || this.tabs.length !== this.panels.length) return;
        tablist.setAttribute('role', 'tablist');
        tablist.hidden = false;
        this.classList.add('nova-tabs-ready');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.activate(next);
            this.tabs[next].focus();
          });
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].setAttribute('tabindex', '0');
        });
        this.activate(0);
      }
      activate(active) {
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('aria-selected', String(index === active));
          tab.tabIndex = index === active ? 0 : -1;
          this.panels[index].hidden = index !== active;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
